import React from 'react';
import { Link } from 'react-router-dom';
import { ASSET_PATHS } from '../../constants';

const Footer: React.FC = () => {
  return (
    <footer className="corporate-footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-section footer-logo-section">
            <img 
              src={ASSET_PATHS.LOGO} 
              alt="LeChalo Logo" 
              className="footer-logo"
            />
            <p className="footer-description">
              Your trusted partner for safe, reliable, and convenient transportation across India.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/press">Press</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Services</h3>
            <ul className="footer-links">
              <li><Link to="/comfy-shuttle/screen">Comfy Shuttle</Link></li>
              <li><Link to="/booking/auto-taxi">Auto & Cab</Link></li>
              <li><Link to="/booking/loading">Loading</Link></li>
              <li><Link to="/services/on-call">On Call</Link></li>
              {/* <li><Link to="/services/tourist-vehicles">Tours</Link></li> */}
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Support</h3>
            <ul className="footer-links">
              <li><Link to="/support">Help Center</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              {/* <li><Link to="/safety">Safety</Link></li> */}
              <li><Link to="/driver-partners">Driver Partners</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Legal</h3>
            <ul className="footer-links">
              <li><Link to="/legal/privacy">Privacy Policy</Link></li>
              <li><Link to="/legal/terms">Terms of Service</Link></li>
              <li><Link to="/legal/cancellation">Cancellation Policy</Link></li>
              <li><Link to="/legal/bus-ticket-booking-privacy">Bus Ticket Booking Privacy Policy</Link></li>
              <li><Link to="/legal/bus-ticket-booking-terms">Bus Ticket Booking Terms & Conditions</Link></li>
              <li><Link to="/insurance">Insurance</Link></li>
            </ul>
          </div>

          <div className="footer-section display-none">
            <h3 className="footer-title">Cities</h3>
            <div className="cities-grid">
              <div className="city-group">
                <h4>Major Cities</h4>
                <ul className="footer-links">
                  <li><Link to="/city/mumbai">Mumbai</Link></li>
                  <li><Link to="/city/delhi">Delhi NCR</Link></li>
                  <li><Link to="/city/bangalore">Bangalore</Link></li>
                  <li><Link to="/city/hyderabad">Hyderabad</Link></li>
                </ul>
              </div>
              <div className="city-group">
                <h4>Other Cities</h4>
                <ul className="footer-links">
                  <li><Link to="/city/chennai">Chennai</Link></li>
                  <li><Link to="/city/pune">Pune</Link></li>
                  <li><Link to="/city/ahmedabad">Ahmedabad</Link></li>
                  <li><Link to="/city/kolkata">Kolkata</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Download App Section */}
        <div className="download-section">
          <div className="download-content">
            <h3 className="download-title">Download our app now!</h3>
            <div className="download-buttons">
              <a 
                href="https://apps.apple.com/app/lechalo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="download-btn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <div className="btn-text">
                  <span className="btn-label">Download on the</span>
                  <span className="btn-name">App Store</span>
                </div>
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=com.leChalo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="download-btn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                <div className="btn-text">
                  <span className="btn-label">GET IT ON</span>
                  <span className="btn-name">Google Play</span>
                </div>
              </a>
            </div>
          </div>
          <div className="qr-code">
            <div className="qr-placeholder">
              <svg width="120" height="120" viewBox="0 0 120 120">
                <rect width="120" height="120" fill="white" stroke="#e2e8f0"/>
                <rect x="10" y="10" width="20" height="20" fill="black"/>
                <rect x="40" y="10" width="20" height="20" fill="black"/>
                <rect x="70" y="10" width="20" height="20" fill="black"/>
                <rect x="10" y="40" width="20" height="20" fill="black"/>
                <rect x="40" y="40" width="20" height="20" fill="black"/>
                <rect x="70" y="40" width="20" height="20" fill="black"/>
                <rect x="10" y="70" width="20" height="20" fill="black"/>
                <rect x="40" y="70" width="20" height="20" fill="black"/>
                <rect x="70" y="70" width="20" height="20" fill="black"/>
              </svg>
            </div>
            <p className="qr-text">Scan the QR Code to download</p>
          </div>
        </div>

        {/* Social Media */}
        <div className="social-section">
          <h3 className="social-title">Follow us on</h3>
          <div className="social-links">
            <a 
              href="https://www.facebook.com/lechalo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link" 
              aria-label="Facebook"
            >
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a 
              href="https://twitter.com/lechalo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link" 
              aria-label="Twitter"
            >
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
              </svg>
            </a>
            <a 
              href="https://www.instagram.com/lechalo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link" 
              aria-label="Instagram"
            >
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.014 5.367 18.647.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.418-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.928.875 1.418 2.026 1.418 3.323s-.49 2.448-1.418 3.244c-.875.807-2.026 1.297-3.323 1.297zm7.83-9.281c-.49 0-.928-.175-1.297-.49-.368-.315-.49-.753-.49-1.243 0-.49.122-.928.49-1.243.369-.315.807-.49 1.297-.49s.928.175 1.297.49c.368.315.49.753.49 1.243 0 .49-.122.928-.49 1.243-.369.315-.807.49-1.297.49z"/>
              </svg>
            </a>
            <a 
              href="https://www.linkedin.com/company/lechalo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-link" 
              aria-label="LinkedIn"
            >
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="company-info">
              <p className="company-name">© 2025 LeChalo Transportation Services Pvt. Ltd.</p>
              <p className="company-address">
                Registered Office: 123 Business Park, Main Street, Mumbai-400001, Maharashtra
              </p>
              <p className="company-details">
                CIN: U74999MH2025PTC123456 | Email: <a href="mailto:help@lechalo.com">help@lechalo.com</a> | Phone: <a href="tel:+918012345678">080 1234 5678</a>
              </p>
            </div>
            <div className="footer-bottom-links">
              <Link to="/legal/privacy">Privacy Policy</Link>
              <Link to="/legal/terms">Terms of Service</Link>
              <Link to="/legal/cancellation">Cancellation Policy</Link>
              <Link to="/legal/bus-ticket-booking-privacy">Bus Ticket Booking Privacy</Link>
              <Link to="/legal/bus-ticket-booking-terms">Bus Ticket Booking Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
